import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  wrapper: {
    height: "100%",
    width: "100%",
  },
  workflowCodePanel: (workflowDefState) => ({}),
  workflowGraph: (workflowDefState) => ({}),
  resizer: (workflowDefState) => ({
    display: workflowDefState.toggleGraphPanel ? "block" : "none",
    width: 8,
    cursor: "col-resize",
    backgroundColor: "rgb(45, 45, 45, 0.05)",
    resize: "horizontal",
    "&:hover": {
      backgroundColor: "rgb(45, 45, 45, 0.3)",
    },
  }),
  workflowName: {
    fontWeight: "bold",
    height: '20px',
    fontSize: "0.75rem"
  },
  rightButtons: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 8,
    height: "32px",
    "&>button": {

      padding: "4px 0",
      fontSize: "0.75 rem",
      fontFamily: "Poppins, regular",
      height: "32px",
    },
  },

  verSelect: {
    height: "32px",
    "&>.MuiSelect-root": {
      height: "32px",
      minHeight: "32px",
      paddingTop: 6,
      paddingBottom: 6,
      paddingRight: "24px !important",
    },
    "& .MuiSelect-select": {
      height: "32px",
      minHeight: "32px",
      display: "flex",
      alignItems: "center",
      fontSize: "0.75rem",
    },
  },
  togglebtn: (workflowDefState) => ({
    display: !workflowDefState.toggleGraphPanel ? "flex" : "none",

    position: "relative",
    top: "-98%",
    left: "96%",
    backgroundColor: "var(--theme-primary)",
  }),
  editorLineDecorator: {
    backgroundColor: "rgb(45, 45, 45, 0.1)",
  },
  workflowDefTabs: {
    // marginBottom: "1rem",
  },
  workflowDefTabPannels: {
    height: "calc(100vh - 9rem)", //subtracted hieght for tab header and toolbar
    overflow: "auto",
  },
  taskPanel: {
    // background: "#fff",
    padding: 8,
  },
  saveCode: {
    display: "flex",
    marginLeft: ".7rem",
    width: "84%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  rightCodeBtn: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
    gap: 8,

    "&>button": {
      margin: "0.5rem 0",
      padding: "4px 5px",
      fontSize: "0.75rem",
      fontFamily: "Poppins, regular",
      lineHeight: "1.5",
    },
  },
});


export default useStyles;